import React, { useState } from "react";
import { BsCircleFill, BsThreeDotsVertical } from "react-icons/bs";
import { FaEdit, FaTrash } from "react-icons/fa";

const Actions = ({ handleDelete, handleEdit, handleStatusChange, third ,sty,txtcolor}) => {
  const [open, setOpen] = useState(false);
  return (
    <>
     <div  className="position-absolute">
      <div className="d-flex   justify-content-between p-1">
        <button
          onClick={() => setOpen(!open)}
          className="p-0 btn btn-icon btn-sm btn-danger d-flex align-items-center justify-content-center"
        >
          <BsThreeDotsVertical />
        </button>
        {open && (
          <div
            style={sty?sty:{ top: "10px", left: "40px" }}
            className="card position-absolute   p-3"
          >
            <span
              style={{ cursor: "pointer" }}
              className="fs-9 my-1 d-inline-flex justify-content-start column-gap-1 align-items-center"
              onClick={handleEdit}
            >
              <FaEdit size={17} className="text-primary" />
              Edit
            </span>

            <span
              style={{ cursor: "pointer" }}
              className="fs-9 my-1 d-inline-flex justify-content-start column-gap-1 align-items-center"
              onClick={handleDelete}
            >
              <FaTrash size={15} className="text-danger" />
              Delete
            </span>

            <span
              className="fs-9 text-nowrap my-1 d-inline-flex justify-content-start column-gap-1 align-items-center"
              onClick={handleStatusChange}
              style={{ cursor: "pointer" }}
            >
              <BsCircleFill size={15} className={txtcolor || "text-info"} />
              {third}
            </span>
          </div>
        )}
      </div>
      </div>
    </>
  );
};

export default Actions;
